import DatabaseModel from './DatabaseModel.js';

var GrupoProveedor = Object.create(DatabaseModel);

GrupoProveedor.model = 'grupoproveedor';
GrupoProveedor.modelFront = 'gruposproveedor';

export default GrupoProveedor;